export { default as AffiliateApplicationApi } from "./affiliate-application.api";
export * from "./affiliate-application.type";
